<template lang="pug">
#modal-selecionar-dados-finca-padron
    el-dialog.custom-dialog(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='65%'
    )
        template(slot='title')
            .dialog-header
                | {{ $t('mensagens.diagnosticoSocioambiental.selecionarItem') }}
        el-row
            el-table.view-table(
                ref='tabelaModalSelecionarFincaPadronRef',
                :data='dadosPaginado',
                style='width: 100%'
            )
                el-table-column(
                    :label='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.finca")',
                    prop='finca',
                    align='left'
                )
                el-table-column(
                    :label='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.padron")',
                    prop='padron',
                    align='left'
                )
                el-table-column(
                    :label='$t("mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.acao")',
                    align='center',
                    width='90'
                )
                    template(slot-scope='scope')
                        i.custom-cursor(
                            @click='realizarDiagnostico(scope.row.geometria, scope.row.descricaoDist)',
                            title='Diagnostico'
                        )
                            img(
                                src='@/assets/lyra-icons/svg/realizar-diagnostico.svg'
                            )
        .c-pagination
            el-pagination(
                background,
                :page-size='paginacao.pageSize',
                :current-page.sync='paginacao.currentPage',
                layout='prev, pager, next',
                :total='paginacao.totalResult',
                @current-change='mudarPagina'
            )
        footer(slot='footer')
            el-button(@click='modalConfirmacaoVoltar = true', size='big')
                | {{ $t('mensagens.comuns.voltar') }}

    el-dialog.dialogo-aviso(
        :visible.sync='modalConfirmacaoVoltar',
        :destroy-on-close='true',
        :show-close='false',
        width='30%',
        append-to-body
    )
        .conteudo-aviso
            | {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.aoVoltarTelaAnterior') }}

        footer(style='display: flex; justify-content: space-between')
            el-button(@click='modalConfirmacaoVoltar = false', size='mini')
                | {{ $t('mensagens.comuns.cancelar') }}
            el-button(
                type='primary',
                @click='fecharModalDeConfirmacaoVoltar',
                size='mini'
            )
                | {{ $t('mensagens.comuns.prosseguir') }}
</template>

<script>
export default {
    name: 'ModalSelecionarDadosFincaPadron',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            modalConfirmacaoVoltar: false,
            dadosPaginado: [],
            paginacao: {
                pageSize: 10,
                currentPage: 1,
                totalResult: 0
            },
            dadoEnviado: false
        };
    },
    mounted() {},

    watch: {
        show: function () {
            if (this.show) {
                this.dadosPaginado = [];
                this.paginacao = {
                    pageSize: 10,
                    currentPage: 1,
                    totalResult: 0
                };
                this.dadoEnviado = false;
                this.setTableData();
            }
        }
    },

    methods: {
        setTableData() {
            if (!this.dados.length) {
                return;
            }
            const start =
                (this.paginacao.currentPage - 1) * this.paginacao.pageSize;
            const end = start + this.paginacao.pageSize;
            this.dadosPaginado = this.dados.slice(start, end);
            this.paginacao.totalResult = this.dados.length;
        },
        mudarPagina(page) {
            this.paginacao.currentPage = page;
            const start =
                (this.paginacao.currentPage - 1) * this.paginacao.pageSize;
            const end = start + this.paginacao.pageSize;
            this.dadosPaginado = this.dados.slice(start, end);
        },
        realizarDiagnostico(geometria, distrito) {
            if (this.dadoEnviado) return;
            this.dadoEnviado = true;

            this.$emit('retornarDadosSelecionados', {
                geometria,
                distrito,
                caseSelecionado: 'FINCA_PADRON'
            });
        },
        fecharModalDeConfirmacaoVoltar() {
            this.modalConfirmacaoVoltar = false;
            this.dadosPaginado = [];
            this.$emit('voltar');
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-selecionar-dados-finca-padron {
    .custom-cursor {
        cursor: pointer;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
        font-family: 'Roboto', 'sans serif';
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .custom-dialog {
        border-radius: 5px;
    }

    footer {
        display: flex;
        justify-content: space-between;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .el-menu-vertical-demo .el-menu-item.is-active {
        color: #359138;
        border-right: 2px solid #359138;
    }

    .el-menu-vertical-demo span {
        font-size: 14px;
        font-family: 'Roboto', 'sans serif';
        font-weight: 500;
    }

    .view-title {
        margin-left: 15px;
        font-family: 'Roboto', 'sans serif';
        font-size: 16px;
        font-weight: 500;
    }

    .view-table {
        margin-left: 15px;
    }

    .border-left {
        border-left: 1px solid #359138;
    }

    .custom-divider {
        margin-top: 30px !important;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }
}
</style>

<style lang="scss">
label {
    margin: 0 !important;
}

.el-dialog {
    margin-top: 55px !important;
}

.el-dialog__header {
    padding-bottom: 0px !important;
}

.el-dialog__body {
    padding: 10px 20px !important;
}
.dialogo-aviso {
    margin-top: 17vh;

    .el-dialog__header {
        background: #ffffff !important;
    }
    .conteudo-aviso {
        margin-top: 1px;
        margin-bottom: 18px;
        font-size: 17px;
        word-break: normal;
    }
}
</style>
